import { useTranslation } from "@/composables/useTranslation";

const { translate } = useTranslation();

export let isValidated = false;
export let emailValidated = "";

export async function validarEmail() {
    const btnNext = document.getElementById("btnFormNext");
    const error = document.getElementById("errorEmail");
    const email = document.getElementById("forgot_password_form_email").value;
    if (email == "") return false;
    let re = /^([\da-zA-Z_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;

    if (!re.exec(email)) {
        error.innerHTML = translate('label.email_invalid');
        return false;
    } else {
        //Validar correo si existe o no
        await $.ajax({
            url: "/users/validateEmail",
            data: {"email": email, 'userID': 0},
            async: true,
            type: "POST",
            success: function (emailExist) {
                if (emailExist) {
                    error.innerHTML = "";
                    btnNext.removeAttribute("disabled");
                    btnNext.classList.remove("btn-blue-v2m-disabled");
                    isValidated = true;
                    emailValidated = email;
                    return true;
                } else {
                    error.innerHTML = translate('label.email_dont_exists');
                    btnNext.setAttribute("disabled", "");
                    btnNext.classList.add("btn-blue-v2m-disabled");
                    isValidated = false;
                    return false;
                }
            }
        });
    }
}

export async function sendEmail() {
    const btnNext = document.getElementById("btnFormNext");
    btnNext.setAttribute("disabled", "");
    if (isValidated && emailValidated == document.getElementById("forgot_password_form_email").value) {
        //Iniciar proceso de recuperacion del correo
        $.ajax({
            url: "/forgotpassword/sendEmail",
            data: {"email": emailValidated},
            async: true,
            type: "POST",
            success: function (response) {
                //var data = JSON.parse(response);
                if (response['success']) {
                    document.getElementById("inpuEmail").style.display = "none";
                    document.getElementById("inputTextFinish").style.display = "block";
                    document.getElementById("groupButtonStart").style.display = "none";
                    document.getElementById("groupButtonStart_two").style.display = "none";
                    document.getElementById("groupButtonFinish").style.display = "block";
                    //document.getElementById("captchaContainer").style.display = "block";
                } else {
                    btnNext.removeAttribute("disabled");
                    document.getElementById("inpuEmail").style.display = "block";
                    document.getElementById("inputTextFinish").style.display = "none";
                    document.getElementById("groupButtonStart").style.display = "block";
                    document.getElementById("groupButtonStart_two").style.display = "block";
                    document.getElementById("groupButtonFinish").style.display = "none";
                }
            }
        });
    } else {
        btnNext.removeAttribute("disabled");
    }
}
